import { Button, DialogActions } from "@mui/material";
import { useSendSocialOfferContext } from "../logics/context";

export const Actions = () => {
  const handleClose = useSendSocialOfferContext("handleClose");
  const loading = useSendSocialOfferContext("loading");
  const handleSubmit = useSendSocialOfferContext("handleSubmit");
  const onSubmit = useSendSocialOfferContext("onSubmit");
  const attachmentsLoading = useSendSocialOfferContext("attachmentsLoading");

  return (
    <DialogActions>
      <Button variant="outlined" onClick={handleClose} disabled={loading || attachmentsLoading}>
        Annuler
      </Button>
      <Button loading={loading || attachmentsLoading} onClick={handleSubmit(onSubmit)} variant="contained">
        Envoyer
      </Button>
    </DialogActions>
  );
};
